/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentAvailabilitySlotResponse
 */
export interface AppointmentAvailabilitySlotResponse {
    /**
     * 
     * @type {Date}
     * @memberof AppointmentAvailabilitySlotResponse
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentAvailabilitySlotResponse
     */
    end: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentAvailabilitySlotResponse
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentAvailabilitySlotResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentAvailabilitySlotResponse
     */
    bookedCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the AppointmentAvailabilitySlotResponse interface.
 */
export function instanceOfAppointmentAvailabilitySlotResponse(value: object): value is AppointmentAvailabilitySlotResponse {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('bookedCount' in value) || value['bookedCount'] === undefined) return false;
    return true;
}

export function AppointmentAvailabilitySlotResponseFromJSON(json: any): AppointmentAvailabilitySlotResponse {
    return AppointmentAvailabilitySlotResponseFromJSONTyped(json, false);
}

export function AppointmentAvailabilitySlotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAvailabilitySlotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'enabled': json['enabled'],
        'bookedCount': ApiUserTasksGetPageParameterFromJSON(json['bookedCount']),
    };
}

export function AppointmentAvailabilitySlotResponseToJSON(json: any): AppointmentAvailabilitySlotResponse {
    return AppointmentAvailabilitySlotResponseToJSONTyped(json, false);
}

export function AppointmentAvailabilitySlotResponseToJSONTyped(value?: AppointmentAvailabilitySlotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'].toISOString(),
        'end': value['end'].toISOString(),
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'enabled': value['enabled'],
        'bookedCount': ApiUserTasksGetPageParameterToJSON(value['bookedCount']),
    };
}

